<!-- <a href="https://superiorsystems.in/apple" target="_blank" class="floating-coin">
    <div class="coin">
      <div class="front">
        <img src="assets/images/superior.png" alt="Logo">
      </div>
      <div class="back">
        <img src="assets/images/authorized.png" alt="Logo">
      </div>
    </div>
  </a> -->
  
  <div class="page-title-area">
      <img src="assets/images/mdm_banner1.png" alt="Page Background" class="page-bg">
      <button class="back-arrow-btn" (click)="navigateToHome()">
          <i class="fas fa-chevron-left fa-2x"></i>
      </button>
      <div class="container">
          <div class="page-title-content">
              <h2>Mobile Device Management (MDM)</h2>
          </div>
      </div>
  
      <div class="page-shape">
          <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
          <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
          <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
          <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
          <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
      </div>
  </div>
  
  <section class="services-details-area ptb-100">
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="section-title">
                      <h2>Superior Digital's MDM Solutions</h2>
                  </div>
                  <p>We offer comprehensive Mobile Device Management solutions designed to help businesses secure, monitor, and manage their mobile devices efficiently. Our MDM solutions provide the tools you need to maintain control over your company's devices while enabling productivity and ensuring security compliance.</p>
              </div>
          </div>
  
          <div class="scrives-item-2 mt-5">
              <div class="row align-items-center">
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/mdm2.jpeg" alt="image" class="image-container-img"/>
                              </div>
                            </div>
                        <!--   <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/mdm2.png" alt="MDM Solutions">
                          </div> -->
                      </div>
                  </div>
  
                  <div class="col-lg-6">
                      
                      <h2>Key Points of Superior Digital's MDM Solutions</h2>
                      <br>
                      
                      <div class="accordion-container">
                          <div class="accordion">
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Tailored Solutions</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Superior Digital offers Mobile Device Management (MDM) solutions 
                                      customised to meet the unique needs of businesses.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Leading Brands</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>The solutions are sourced from leading brands such as Jamf, Mosyle, 
                                      JumpCloud, VMware, Kandji, Hexnode, and 42Gears.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Scalability and Reliability</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Solutions are scalable and reliable, catering to businesses managing 
                                      from a few devices to thousands.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Comprehensive Management</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Ensures seamless deployment, security, and control across devices.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Policy Enforcement and Security</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Helps businesses enforce policies, secure data, and streamline IT operations.</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
  
          <div class="scrives-item-2 mt-4">
              <div class="row align-items-center">
                  <div class="col-lg-6">
                      
                      <h2>Additional Benefits of Our MDM Solutions</h2>
                      <br>
                      
                      <div class="accordion-container">
                          <div class="accordion">
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Advanced Management Tools</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Provides tools for remote troubleshooting, app distribution, and 
                                      content management to improve efficiency.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Security and Compliance</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Strong security features to protect sensitive information and maintain 
                                      compliance.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Expert Services</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Offer consultation, deployment, and ongoing support to ensure a smooth MDM 
                                      experience.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Diverse Platform Support</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Solutions for both Apple and multi-platform environments to cater to 
                                      diverse enterprise needs.</p>
                                  </div>
                              </div>
                              
                              <div class="accordion-item">
                                  <div class="accordion-header" (click)="toggleAccordion($event)">
                                      <h3>Optimisation and Productivity</h3>
                                      <i class="bx bx-chevron-down"></i>
                                  </div>
                                  <div class="accordion-content">
                                      <p>Aims to optimise mobile workforce and enhance productivity by 
                                      empowering organisations with the right MDM solution.</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/mdm1.jpeg" alt="image" class="image-container-img" style="object-fit: cover !important;"/>
                              </div>
                            </div>
                         <!--  <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/mdm3.png" alt="MDM Support">
                          </div> -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  
  <div class="container mb-4">
      <div class="d-flex justify-content-end">
          <button class="btn back-btn" (click)="navigateToHome()">
              <i class="fas fa-arrow-left me-2"></i> Back to Home
          </button>
      </div>
  </div>
  